import { ILoadSearch } from "../../schemas/Search/Search.schema";
import { setObject, getObject } from "../../utils/common";
import { error, load } from "./Loads.model";

export class Search implements ILoadSearch {
  size?: number;
  page?: number;
  sortColumn?: string;
  sortDirection!: string;
  managedEquipmentCapability?: string;
  nonManagedEquipmentCapability?: string;
  originCity?: string;
  originState?: string;
  originRadius?: number;
  originCountry?: string;
  originPostalCode?: string;
  pickUpStartDate?: string;
  pickUpEndDate?: string;
  dropStartDate?: string;
  dropEndDate?: string;
  destinationCity?: string;
  destinationStates?: any;
  destinationCountry?: string;
  destinationPostalCode?: string;
  destinationRadius?: number;
  trailerType?: string;
  userId?: string;
  carrierId?: string | null ;
  carrierScac?: string;
  userRole?: string;
  skipUserSearchHistory?: boolean;
  favorite?: boolean;
  carrierTier?: string;
  distance = "mi";


  getRequestPayload() {
    const excludedProperties = [
      "skipUserSearchHistory",
      "distance",
      "carrierTier",
      "favorite"
    ];
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function" && !excludedProperties.includes(key) && 
      (key === "managedEquipmentCapability"||key ==="nonManagedEquipmentCapability")) input[key] = value || "";
      else if (typeof value !== "function" && !excludedProperties.includes(key)) input[key] = value;
    }
    const { similarLoads, ...updatedLoad } = load;
    return {
      query: {
        searchLoadPostingV2: {
          __args: {
            input
          },
          totalRecords: true,
          loadPostings: {
            ...updatedLoad,
            managedEquipment: true,
            exclusiveLoad: true,
            specialServices: {
              serviceDesc: true,
              specialServiceDesc: true
            }
          },
          message: true,
          status: true,
          error: error
        }
      }
    };
  }
  persistLoads(_loads: []) {
    return setObject("Search-Loads", _loads);
  }

  getLoads() {
    return getObject("Search-Loads");
  }
  recentLoads(_loads: []) {
    return setObject("Recent-Loads", _loads);
  }
  getRecentLoads() {
    return getObject("Recent-Loads");
  }
  favoriteLoads(_loads: []) {
    return setObject("Favorite-Loads", _loads);
  }
  getfavoriteLoadss() {
    return getObject("Favorite-Loads");
  }
}
const searchModel = new Search();
Object.freeze(searchModel);

export default searchModel;
